module.exports = __webpack_public_path__ + "static/media/kiosk.637dee04.svg";